import store from 'utils/store/withMiddleware'
import {
  ALL_DENTAL,
  ALL_VISION,
  AMERITAS_DENTAL,
  LATITUDE,
  SUPPLEMENTAL_BENEFIT,
  VISION,
  VISION_ID
} from 'core/constants/products'
import stickySummary from '../components/plan-summary/sticky'
import { ADD_PLAN, REMOVE_PLAN } from 'messages'
import toastNotification from 'pug/toastNotification'
import getById from 'utils/DOM/getById'

/** When an add-on checkbox is toggled, update the state by adding or removing add-ons */
export function handleToggleAddOnCheck(event) {
  event.preventDefault()
  const deletePlans =
    (typeof this.checked !== 'undefined' && !this.checked) ||
    this.classList.contains('remove')
  const selectedPlanIds = this.getAttribute('data-ids')
    .split(',')
    .map(s => parseInt(s))

  handleToggleAddOn({ selectedPlanIds, deletePlans })
}

/** When an add-on button in one of the modals is pressed, add the new product. */
export function handleClickAddOnBtn(event) {
  event.preventDefault()
  const selectedPlanIds = this.getAttribute('data-ids')
    .split(',')
    .map(s => parseInt(s))
  handleToggleAddOn({ selectedPlanIds, deletePlans: false })
}

/** When the vision checkbox is toggled, add or remove Renaissance vision. */
export function handleToggleVision(event) {
  event.preventDefault()
  const deletePlans = !this.checked
  const state = store.getState()
  const selectedPlanId = state.plans[VISION_ID].planId

  handleToggleAddOn({ selectedPlanIds: [selectedPlanId], deletePlans })
}

/**
 * When one of the add-on selectors is activated,
 * add or remove the selected plans from the state.
 */
export function handleToggleAddOn({
  selectedPlanIds,
  deletePlans
}: {
  selectedPlanIds: number[]
  deletePlans: boolean
}) {
  const visionChecked = getById('vision-checkbox').checked
  if (visionChecked) selectedPlanIds.push(VISION_ID)

  const state = store.getState()
  if (deletePlans) {
    const addOns = state.addOns.filter(id => !selectedPlanIds.includes(id))
    store.update({ addOns })
  } else {
    // To determine the new list of add-ons, we first construct a Set
    // with the newly selected product types.
    // Then, for each of the old add-ons, if the old add-on's type is
    // incompatible with one of the new products, then filter out the old one.
    const selectedProducts = selectedPlanIds.map(id => state.plans[id].productId)
    const addOnsToKeep = state.addOns.filter(id => {
      const oldProduct = state.plans[id].productId
      if (
        ALL_DENTAL.includes(oldProduct) &&
        ALL_DENTAL.some(id => selectedProducts.includes(id))
      ) {
        // If the old product is a dental product and one of the new ones is a dental product,
        // remove the old dental product
        return false
      } else if (
        ALL_VISION.includes(oldProduct) &&
        ALL_VISION.some(id => selectedProducts.includes(id))
      ) {
        // If the old product is a vision product and one of the new ones is a vision product,
        // remove the old product
        return false
      } else if (oldProduct === LATITUDE && selectedProducts.includes(LATITUDE)) {
        // If the old product is Latitude and one of the new products is Latitude,
        // remove the old product
        return false
      } else if (
        oldProduct === SUPPLEMENTAL_BENEFIT &&
        selectedProducts.includes(SUPPLEMENTAL_BENEFIT)
      ) {
        // If the old product is supplemental and one of the new products is supplemental,
        // remove the old product
        return false
      } else if (oldProduct === VISION && selectedProducts.includes(AMERITAS_DENTAL)) {
        // If the old product is a Renaissance vision product, but we're now buying an
        // Ameritas dental product, then we need to remove the old Renaissance vision product,
        // since we can only get Renaissance vision with Brilliant Dental.
        return false
      } else {
        // No overlap - keep the old product
        return true
      }
    })

    const newAddOns = selectedPlanIds.concat(addOnsToKeep)
    if (!newAddOns.includes(VISION_ID)) {
      const visionCheck = getById<HTMLInputElement>('vision-checkbox')
      if (visionCheck) {
        visionCheck.checked = false
      }
    }

    store.update({ addOns: newAddOns })
  }

  toastNotification(deletePlans ? REMOVE_PLAN : ADD_PLAN)
  stickySummary()
}
